import { getTextField, ValidationError } from '@lender/utils';
import _ from 'lodash';

import { prepareStringForComparison } from 'utils/data';

import { REQUIRED_ALTERNATE_NAMES_FIELDS } from './AlternateName.constants';

const checkIsCompleted = value =>
  !!_.size(value?.value !== undefined ? value : prepareStringForComparison(value));

export const getRequiredAlternateNameFieldSchema = fieldName =>
  getTextField({ isRequired: false }).test(
    `required-if-other-completed`,
    ValidationError.RequiredField,
    function (value) {
      if (!this.parent) {
        return true;
      }

      const { [fieldName]: currentFieldValue, ...otherFields } = this.parent;

      const isCurrentFieldCompleted = checkIsCompleted(value);
      const isSomeOfOtherFieldsCompleted = Object.values(otherFields).some(checkIsCompleted);
      const areRequiredFieldsCompleted = _.without(REQUIRED_ALTERNATE_NAMES_FIELDS, [
        fieldName,
      ]).every(requiredFieldName => checkIsCompleted(_.get(this.parent, requiredFieldName)));

      return isCurrentFieldCompleted || !isSomeOfOtherFieldsCompleted || areRequiredFieldsCompleted;
    },
  );

export const getCorrectedNameInModelByIndex = (initialNameInModel, index) =>
  initialNameInModel.replace('[0]', `[${index}]`);
